// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attention-bar{z-index:1;display:flex;flex-wrap:nowrap;overflow:hidden;margin-bottom:0!important;text-align:center}.attention-bar-text{padding:8px;white-space:nowrap;transform:translateX(-15px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
